import { FlowsQuestion } from '../../../../../../types/FlowsTypes';
import { useAskLaterQuestions } from '../api/getAskLaterQuestion';

const useIsCheckedAskedLater = (question: FlowsQuestion): boolean => {
  const { data } = useAskLaterQuestions();

  return Boolean(
    data?.questions.find(({ question_id }) => question_id === question.id)
      ?.active,
  );
};

export default useIsCheckedAskedLater;
